import { Outlet, createRootRoute, Link } from '@tanstack/react-router'
import { AuthProvider } from '../auth/AuthContext'

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-gray-50">
        <header className="bg-white shadow-sm border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center gap-6">
            <h1 className="text-xl font-semibold text-gray-900">Foreclosure Surplus</h1>
            <nav className="flex gap-4">
              <Link
                to="/"
                className="text-sm text-gray-600 hover:text-gray-900 [&.active]:font-semibold [&.active]:text-gray-900"
              >
                Auctions
              </Link>
              <Link
                to="/deals"
                className="text-sm text-gray-600 hover:text-gray-900 [&.active]:font-semibold [&.active]:text-gray-900"
              >
                Deals
              </Link>
            </nav>
          </div>
        </header>
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Outlet />
        </main>
      </div>
    </AuthProvider>
  )
}